module.exports = __webpack_public_path__ + "img/图层44.76394e5a.png";